import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MCard from "components/Shared/MCard.tsx";
import { userHasRight } from "selectors/rights";
import { INSPECTION_EVENT_WATCH, APPRAISAL_EVENT_WATCH } from "typeConstants/rights";
import { DATA_TYPE_BOOLEAN } from "typeConstants/dataTypes";
import { getWatches, updateWatches, getAvailableWatches } from "requests/watches";

const WatchedCaseEvents = ({ internetUserId, hasInspectionWatchRight, hasAppraisalWatchRight }) => {
  const [enabledWatches, setEnabledWatches] = useState(null);
  const [availableWatches, setAvailableWatches] = useState(null);
  const mounted = useRef(true);
  
  useEffect(() => {
    getWatches(internetUserId, setEnabledWatches, mounted);
    getAvailableWatches(internetUserId, setAvailableWatches, mounted);
    return () => mounted.current = false;
  }, []);

  const getWatchField = (watch) => {
    return {
      label: watch.name,
      value: enabledWatches?.filter((enabled) => enabled.code === watch.code)?.length ? true : false,
      key: watch.id.toString(),
      editable: (watch.isInspectionWatch && hasInspectionWatchRight)
        || (watch.isAppraisalWatch && hasAppraisalWatchRight),
      dataType: DATA_TYPE_BOOLEAN,
    };
  };

  const getWatchFields = () => availableWatches?.sort((a, b) => a.displayOrder - b.displayOrder)?.map(getWatchField);

  const onEditFinished = (editFields) => {
    if (editFields.length > 0) {
      saveWatches(editFields);
    }
  };

  const saveWatches = (editFields) => {
    setEnabledWatches(null);
    updateWatches(internetUserId,
      editFields.filter((f) => f.value).map((f) => f.key),
      editFields.filter((f) => !f.value).map((f) => f.key),
      setEnabledWatches,
      mounted);
  };

  return (
    <MCard
      isFetching={!enabledWatches}
      title="Watched Case Events"
      fields={getWatchFields()}
      isEditable={hasInspectionWatchRight || hasAppraisalWatchRight}
      onEditFinished={onEditFinished} 
    />
  );
};

WatchedCaseEvents.propTypes = {
  internetUserId: PropTypes.number,
  hasInspectionWatchRight: PropTypes.bool,
  hasAppraisalWatchRight: PropTypes.bool,
};

const mapStateToProps = state => ({
  internetUserId: state.user.profile.internetUserId,
  hasInspectionWatchRight: userHasRight(INSPECTION_EVENT_WATCH)(state),
  hasAppraisalWatchRight: userHasRight(APPRAISAL_EVENT_WATCH)(state),
});

export default connect(mapStateToProps)(WatchedCaseEvents);